import styled from 'styled-components/macro';

export const GrassInfoColumn = styled.div`
  width: ${({ variableWidth }) => (variableWidth ? 'auto' : '250px')};
  padding: 10px;
  display: flex;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    padding: 5px 0;
    ${({ inColumn }) =>
      inColumn && 'flex-direction:column;align-items:flex-start;'}
  }
`;

export const IconContainer = styled.div`
  width: 37px;
  height: 37px;
  border-radius: 50%;
  background-color: ${props => props.theme.green};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  ${({ inColumn }) => !inColumn && 'margin-top:7px;'}

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 30px;
    height: 30px;
    margin-right: 5px;
    ${({ inColumn }) => inColumn && 'margin-bottom:10px;'}
  }
`;

export const Content = styled.div`
  width: ${({ inColumn }) => (inColumn ? '100%' : 'calc(100% - 40px)')};
  height: auto;
  padding-left: 15px;
  border-left: 1px solid ${props => props.theme.green};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    padding-left: 5px;
    height: ${({ inColumn }) => (inColumn ? 'calc(100% - 40px)' : '100%')};
  }
`;

export const Label = styled.p`
  text-transform: capitalize;
  font-family: ${props => props.theme.primaryFontBold};
  font-size: ${({ theme }) => theme.paragraphSmall}px;
  font-family: ${({ theme }) => theme.primaryFontMedium};
`;

export const TextContent = styled.p`
  text-transform: capitalize;
  font-family: ${({ theme, light }) =>
    light ? theme.primaryFontLight : theme.primaryFontBold};
  font-size: ${({ theme }) => theme.paragraph}px;
  margin-top: ${({ pushTop, theme }) => pushTop && theme.paragraph}px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    padding: 5px 0;
    ${({ inColumn }) =>
      inColumn && 'flex-direction:column;align-items:flex-start;'}

    > div {
      &:first-child {
        width: 30px;
        height: 30px;
        margin-right: 5px;
        ${({ inColumn }) => inColumn && 'margin-bottom:10px;'}
      }

      &:last-child {
        padding-left: 5px;
        width: ${({ inColumn }) =>
          inColumn
            ? 'height:calc(100% - 40px);width:100%;'
            : 'calc(100% - 40px)'};
      }
    }
  }
`;
